<template>
	<div>
		<div class="row " >
			<div class="col-12 col-md-8 mx-auto">
				<reports-filter v-if="components.filter" :event="event" :vendors="vendors" :isLoading="isLoading.vendors"/>
			</div>
			<div class="col-12 mx-auto">
				<reports-list v-if="components.reports" :event="event"/>
			</div>

		</div>
	</div>
</template>
<script>
	import {
		Card,
		Table as NTable,
		AnimatedNumber,
		Progress as NProgress,
	} from "@/components";
	import axios from 'axios';
	import { useToast } from "vue-toastification";
	import { Notification } from "@/components";
	import ReportsFilter from './ReportsFilter';
	import ReportsList from './ReportsList';
	import { ElDivider, ElBadge, ElMessage } from "element-plus";

	export default {
		components: {
			Card,
			NTable,
			AnimatedNumber,
			NProgress,
			ReportsFilter,
			ReportsList,
			ElDivider, ElBadge
		},
		inject: ['$baseURL', '$numFrm', '$formatDateTime', '$isCheckEventType'],
		emits: [ 'event-fetched', 'info-fetched', 'loading-complete' ],
		data() {
			return {
				defaultInfo: {
					event: { name: '', country: 'india', type: '' },
					summary: {},
					summaryInfo: { topup: { amount: 0, count: 0 }, sale: { amount: 0, count: 0 }, return: { amount: 0, count: 0 }, no_nfc_sale: { amount: 0, count: 0 } },
					vendors: [],
					stalls: [],
					devices: [],
					components: { filter: false, list: false, reports: false, },
					isLoading: { filter: false, list: false, reports: false, },
				},
				loginUser: {},
				event: { name: '', country: 'india', type: '' },
				summary: {},
				summaryInfo: { topup: { amount: 0, count: 0 }, sale: { amount: 0, count: 0 }, return: { amount: 0, count: 0 }, no_nfc_sale: { amount: 0, count: 0 } },
				vendors: [],
				devices: [],
				stalls: [],
				components: { filter: false, list: false, reports: false, },
				isLoading: { filter: false, list: false, reports: false, },
			};
		},
		methods: {
			runToast(text, pos, type, ownText, ownIcon) {
				// const text =
				// 	"Welcome to <b>Vue Now UI Dashboard Pro</b> - a beautiful premium dashboard for every web developer";
				const icon = "now-ui-icons ui-1_bell-53";
				const content = {
					component: Notification,

					props: {
						ownText: ownText,
						ownIcon: ownIcon,
						icon: icon,
						text: text,
						type: type,
					},
				};
				const toast = useToast();
				toast(content, {
					hideProgressBar: true,
					icon: false,
					closeButton: false,
					position: pos,
				});
			},
			setComponentsDisplay () {
				this.setDefault('components');
				// console.log(this.event.type);

				switch(this.event.type) {
					case 'event':
						this.components.filter = true;
						// this.components.reports = true;
						break;
					case 'clg-access':
						break;
				}
			},
			setDefault(key = 'all') {
				if(key !== 'all')  this[key] = JSON.parse(JSON.stringify(this.defaultInfo[key]));
				else {
					for (const [key, value] of Object.entries(this.defaultInfo)) {
						this[key] = JSON.parse(JSON.stringify(value));
					}
				}
			},
			devicesUpdated(devices) { console.log('device-added', devices) },
			eventUpdated(event) {
				if(!event)  return;
				this.event = event;
				this.$emit('event-fetched', event);
			},
			dataLoad() {
				if(this.$isCheckEventType('fnb', this.event.type)) {
					this.loadConfigData('Vendors');
				}
				this.$emit('loading-complete');
			},
			loadData(dataType) {
				this.isLoading[dataType] = true;
				let u = this.loginUser, code = 0, url = '';
				switch (u.loginType) {
					case 'event':
					case 'operator':
						code = u.id;
						break;
					case 'admin':
						code = this.$route.params.code;
						break;
					default:
						return ;
						break;
				}

				axios.get(
					this.$baseURL + '/Vendors/ViewAll',
					{
						id: code, dataType, eventType: this.event.type,
					},
					{ headers: { Authorization: `Bearer ${localStorage.getItem('xToken')}` }}
				)
					.then(response => {
						// console.log(response);
						if(response.data.success) { this.updateLocal(dataType, response.data); }
					})
					.catch( (error) => {
						this.runToast('', 'top-right', 'danger', "<b>Something went wrong</b><br>Please try again.", "fas fa-bomb fa-4x");
						console.log("err:", error);
						this.isLoading[dataType.toLowerCase()] = false;
					});

			},
			loadConfigData(dataType) {
				axios.get(
					this.$baseURL + '/' + dataType + '/event-wise/',
					{ params: { code: this.event.id }, headers: { Authorization: `Bearer ${localStorage.getItem('xToken')}` }}
				)
					.then(response => {
						// console.log(response);
						this.setDefault(dataType.toLowerCase());
						this[dataType.toLowerCase()] = response.data[dataType.toLowerCase()];
						this.isLoading[dataType.toLowerCase()] = false;

						// if(dataType === 'Vendors') {
						// 	this.setDefault('vendorsFilter');
						// 	response.data.vendors.forEach(vendor => { this.vendorsFilter.push({ text: vendor.name, value: vendor.name }) });
						// }
					})
					.catch( (error) => {
						this.runToast('', 'top-right', 'danger', "<b>Something went wrong</b><br>Please try again.", "fas fa-bomb fa-4x");
						console.log("err:", error);
						this.isLoading[dataType.toLowerCase()] = false;
					});
			},
			loadDetails() {
				let u = this.loginUser, code = 0, url = '';
				switch (u.loginType) {
					case 'event':
					case 'operator':
						code = u.id;
						url = this.$baseURL + '/Event/Details/';
						break;
					case 'reports':
					case 'admin':
						code = this.$route.params.code;
						url = this.$baseURL + '/Event/Details/';
						break;
					case 'vendor':
						code = u.id;
						url = this.$baseURL + '/Vendors/Details/';
						break;
					default:
						return ;
						break;
				}
				axios.get(
					url,
					{ params: { code }, headers: { Authorization: `Bearer ${localStorage.getItem('xToken')}` }}
				)
					.then(response => {
						this.setDefault('event');
						if(response.data.success) {
							if(this.loginUser.loginType !== 'vendor') {
								this.event = response.data.event;
								this.isLoading.event = false;
								this.dataLoad();
								this.$emit('event-fetched', this.event);
							} else {
								this.vendor = response.data.vendor;
								this.event = response.data.event;
								this.vendors = [this.vendor];
								this.$emit('info-fetched', this.vendor);
								this.$emit('event-fetched', response.data.event);
								this.$emit('loading-complete');
							}
							this.setComponentsDisplay();
						} else {
							ElMessage({
								showClose: true,
								dangerouslyUseHTMLString: true,
								message: "<b>Something went wrong</b><br>" + response.data.message,
								type: 'danger',
								grouping: true,
								duration: 5000,
							});
						}
					})
					.catch( (error) => {
						ElMessage({
							showClose: true,
							dangerouslyUseHTMLString: true,
							message: "<b>Something went wrong</b><br>Please try again.",
							type: 'danger',
							grouping: true,
							duration: 5000,
						});
						console.log("err:", error);
					});
			},
		},
		mounted() {
			let u = JSON.parse(localStorage.getItem('user'));
			this.loginUser = u;
			if (!u || Object.keys(u).length === 0 && u.constructor === Object && (u.loginType !== 'admin' && u.loginType !== 'reports') ) return this.$router.push('/login');
			this.loadDetails();
		},
		watch: {
			$route (to, from){
				let u = JSON.parse(localStorage.getItem('user'));
				this.loginUser = u;
				if (!u || Object.keys(u).length === 0 && u.constructor === Object && (u.loginType !== 'admin' && u.loginType !== 'reports') ) return this.$router.push('/login');
				this.loadDetails();
			},
		}
	};
</script>
<style>
	.aml-card-header {
		border-radius: .5875rem !important;
		min-height: 100px;
		/*background-color: #2198af !important;*/
	}
	.aml-event-card {
		/*box-shadow: 0 1px 15px 1px rgb(39 39 39 / 35%) !important;*/
		box-shadow: 0 1px 15px 1px rgb(256 256 256) !important;
	}
</style>
